import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import DocumentName from '../DocumentName/DocumentName';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import Modal from '../../Common/Modal/Modal';
import {labels} from '../../../util/utils';
import {clearErrors} from '../../../actions/erroractions';
import {deleteDocumentById} from '../../../actions/Document/documentactions';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import {clientSideEventNames, documentTypes} from '../../../util/uiconstants';

export default function DeleteDocument(props) {
	const {
		engagementId,
		document,
		onDocumentDeleted,
		showDeleteModal,
		setShowDeleteModal,
		viewKey,
		entityUId,
		parentName,
		sectionId,
		deleteDocumentAction,
		instructionId = null
	} = props;

	const [isDeleting, setIsDeleting] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearErrors()).then(function() {
			dispatch(setIsModalOpen(true));
		});
		return () => {
			dispatch(clearErrors());
		};
	}, []);

	const handlerDeleteDocument = () => {
		setIsDeleting(true);

		let action = deleteDocumentAction ? deleteDocumentAction : deleteDocumentById;
		dispatch(action(engagementId, document.id, entityUId, viewKey, 'delete', parentName, instructionId, sectionId))
			.then(() => {
				window.dispatchEvent(new CustomEvent(clientSideEventNames.entityFormDeleted));
				if (props.document.documentTypeId === documentTypes.ALRA_INDIVIDUAL) {
					window.dispatchEvent(new CustomEvent(clientSideEventNames.getAccountsForBody));
				}

				if (props.document.documentTypeId === documentTypes.ESTIMATESDOCUMENT) {
					window.dispatchEvent(new CustomEvent(clientSideEventNames.estimateDocumentDeleted));
				}

				if (props.document.documentTypeId === documentTypes.MULTIENTITYINDIVIDUALPROFILE) {
					window.dispatchEvent(new CustomEvent(clientSideEventNames.documentDeleted));
				}

				if (onDocumentDeleted) {
					onDocumentDeleted(document, viewKey);
				}
			})
			.catch(() => {
				setIsDeleting(false);
			});
	};

	const onCancel = () => {
		dispatch(setIsModalOpen(false));
		setShowDeleteModal(false);
	};

	return (
		<Wrapper className="DeleteDocumentWrapper">
			<Modal
				title={labels.deleteFileTitle}
				onOkClick={() => handlerDeleteDocument()}
				onHide={() => onCancel()}
				show={showDeleteModal}
				modalsize="x-small"
				showButtons
				closeBtnTitle={labels.cancelLabel}
				confirmBtnTitle={labels.confirmLabel}
				closeTitle={labels.closeLabel}
				isOkButtonDisabled={isDeleting}
				isCancelButtonDisabled={isDeleting}
				modalContainerClass="DeleteDocumentModalContainer"
				modalbodystyle="DeleteDocumentModalBody"
			>
				<StyledDeleteDocument className={`StyledDeleteDocument DeleteDocument ${isDeleting ? 'isDeleting' : ''}`}>
					{isDeleting && <LoadingIndicator view={'fullview'} show />}
					<h5 className="confirm-msg">{labels.deleteFileModalMessage}</h5>
					<DocumentName
						engagementId={props.document.engagementId}
						documentName={props.document.documentName}
						documentTypeId={props.document.documentTypeId}
						fileExt={props.document.fileExt}
						fileSizeKB={props.document.fileSizeKB}
						hasComments={props.document.hasComments}
						hasHiddenSheets={props.document.hasHiddenSheets}
						hasHighlights={props.document.hasHighlights}
						isConflicted={props.document.isConflicted}
						trackChange={props.document.trackChange}
						isReturned={props.document.isReturned}
						isReadOnly={props.document.isReadOnly}
						size="medium"
					/>
				</StyledDeleteDocument>
			</Modal>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	.motif-modal-content {
		.motif-modal-body.DeleteDocumentModalBody {
			min-height: var(--px-100);
		}
	}
`;

const StyledDeleteDocument = styled.section`
	font-size: var(--px-14);
	&.isDeleting {
		.motif-progress-loader {
			position: absolute;
			left: 50%;
		}
		.confirm-msg,
		.DocumentNameWrapper {
			opacity: 0.5;
		}
	}
	.errorMessageWrapper {
		width: 100%;
		margin-top: calc(var(--px-10) * -1);
	}
	.confirm-msg {
		margin: 0 0 var(--px-20) 0;
		font-weight: bold;
		font-size: var(--px-14);
	}
	.DocumentNameWrapper {
		padding: 0;
		.DocumentName {
			font-size: var(--px-14);
		}
		.DocumentSVG {
			svg {
				cursor: default;
			}
		}
	}
`;
